import { AbstractBackendService } from '../../prototypes/backend.service';
import { DashboardStats } from '@core/models/dashboardStats';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExceptionHandlerService } from '@core/services/exceptionhandler/exception.handler.service';
import { catchError, Observable, of } from 'rxjs';
import { AuthoritiesToSignChart } from '@core/models/authoritiesToSignChart';
import { AreasCitiesCompaniesGremium } from '@core/models/areasCitiesCompaniesGremium';
import { Countries } from '@core/models/countries';

/**
 * The EmployeeDetailsService interface is an extension of a standard backend service. It adds a method to retrieve the
 * profile image of an employee.
 */
@Injectable({
  providedIn: 'root'
})
export class DashboardService extends AbstractBackendService<DashboardStats> {
  constructor(
    http: HttpClient,
    private exceptionService: ExceptionHandlerService
  ) {
    super(`/api/dashboard`, http);
  }

  override get(): Observable<DashboardStats> {
    return this.http
      .get<DashboardStats>(this.endPointUrl)
      .pipe(catchError(this.exceptionService.handleError<DashboardStats>()));
  }

  getAuthoritiesToSignChart(): Observable<AuthoritiesToSignChart> {
    return this.http
      .get<AuthoritiesToSignChart>(this.endPointUrl + '/graph/authoritiesToSignChart')
      .pipe(catchError(this.exceptionService.handleError<AuthoritiesToSignChart>()));
  }

  getAreas(): Observable<AreasCitiesCompaniesGremium> {
    return this.http
      .get<AreasCitiesCompaniesGremium>(this.endPointUrl + '/graph/area')
      .pipe(catchError(this.exceptionService.handleError<AreasCitiesCompaniesGremium>()));
  }

  getCities(): Observable<AreasCitiesCompaniesGremium> {
    return this.http
      .get<AreasCitiesCompaniesGremium>(this.endPointUrl + '/graph/cities')
      .pipe(catchError(this.exceptionService.handleError<AreasCitiesCompaniesGremium>()));
  }

  getCompanies(): Observable<AreasCitiesCompaniesGremium> {
    return this.http
      .get<AreasCitiesCompaniesGremium>(this.endPointUrl + '/graph/companies')
      .pipe(catchError(this.exceptionService.handleError<AreasCitiesCompaniesGremium>()));
  }

  getGremium(): Observable<AreasCitiesCompaniesGremium> {
    return this.http
      .get<AreasCitiesCompaniesGremium>(this.endPointUrl + '/graph/gremium')
      .pipe(catchError(this.exceptionService.handleError<AreasCitiesCompaniesGremium>()));
  }

  getCountries(): Observable<Countries> {
    return this.http
      .get<Countries>(this.endPointUrl + '/graph/countries')
      .pipe(catchError(this.exceptionService.handleError<Countries>()));
  }
}
